import { useEffect, useRef, useState } from 'react';
import { Hierarchy } from '../../hierarchy';
import { useStageToolbarState } from '../../states/stage-toolbar-state';
import type { IStageToolbarItemRenderArgs } from '../../types';
import { HierarchyActionBridge } from './action-bridge';

const DEFAULT_POSITION = { right: 276, bottom: 60 };

export const PanelHierarchyItem = ({ active, setActive, toolbar }: IStageToolbarItemRenderArgs) => {
    const triggerRef = useRef<HTMLDivElement>(null);
    const activeRef = useRef(active);
    const [renderPanel, setRenderPanel] = useState(active);
    const position = useStageToolbarState()((state) => state.hierarchyPanelPosition);

    activeRef.current = active;

    useEffect(() => {
        // 重新打开时立即保留 Panel；关闭则等待 DragPopover 的退出动画结束后再卸载。
        if (active) setRenderPanel(true);
    }, [active]);

    return (
        <>
            <HierarchyActionBridge toolbar={toolbar} />
            <div
                ref={triggerRef}
                className="stage-toolbar-hierarchy"
                onMouseDown={(event) => {
                    event.stopPropagation();
                    // Panel 右边缘应对齐整条工具栏；若只取当前按钮，会向左偏移后续缩放区域的宽度。
                    const toolbarElement = triggerRef.current?.closest('.l-navigator');
                    const rect = toolbarElement?.getBoundingClientRect() ?? triggerRef.current?.getBoundingClientRect();
                    if (rect) DEFAULT_POSITION.right = window.innerWidth - rect.right;
                }}
            >
                <Hierarchy.Trigger open={active} onOpenChange={setActive} />
                {renderPanel ? (
                    <Hierarchy.Panel
                        motion={active ? 'enter' : 'leave'}
                        position={{
                            ...DEFAULT_POSITION,
                            ...position,
                        }}
                        onClose={() => setActive(false)}
                        onMotionEnd={() => {
                            // 快速重新打开时忽略旧退出动画，避免误卸载当前已激活的面板。
                            if (!activeRef.current) setRenderPanel(false);
                        }}
                    />
                ) : null}
            </div>
        </>
    );
};
